//////////////// Localization Begin ////////////////
export const NETWORK_CONNECTION_MESSAGE =
  "Cannot connect to server, Please try again.";
export const NETWORK_TIMEOUT_MESSAGE =
  "A network timeout has occurred, Please try again.";
export const UPLOAD_PHOTO_FAIL_MESSAGE =
  "An error has occurred. The photo was unable to upload.";
export const NOT_CONNECT_NETWORK = "NOT_CONNECT_NETWORK";

// API Localhost
// export const apiUrl = "http://localhost:3000";
// export const imageUrl = "http://localhost/image";

export const apiKeyTiny = "iwpxfawesh9p955xh8fpa9bnfe3kn93aj5mef6n8ds67h9xg";

// export const apiUrl = "http://localhost:2087";
// export const apiUrlImmigration = "http://localhost:2088"; // <-- เพิ่ม
// export const apiUrlInCorporate = "http://localhost:2095"; // <-- เพิ่ม (new_dtime_corporate_service_node_backend)
// export const imageUrl = "http://localhost:3001/images";
// export const imageProdStorageUrl = "http://localhost:3001/leaveimage";
// export const fileSaleorderUrl = "http://localhost:3001/saleorderfiles";
// export const imageSaleorderUrl = "http://localhost:3001/saleorderimages";
// export const fileClearAdvance = "http://localhost:3001/clearadvancefiles";
// export const imageClearAdvance = "http://localhost:3001/clearadvanceimages";
// export const fileImmigration = "http://localhost:3001/immigrationfiles";
// export const fileImmigrationTransaction =
//   "http://localhost:3001/immigrationtransactionfiles";
// export const filesDdocfile = "http://localhost:3001/d_docfile";
// export const pettyCashFile = "http://localhost:3001/petty_cash_file";
// export const pettyCashImage = "http://localhost:3001/petty_cash_image";
// export const leavequotaFile = "http://localhost:3001/leavequota";
// //-----------at law --------------//
// export const imagemasterTMUrl = "http://localhost:3001/mastertmimages";
// export const filemasterTMUrl = "http://localhost:3001/mastertmfiles";
// export const imageappointmentTMUrl =
//   "http://localhost:3001/appointmenttmimages";
// export const fileappointmentTMUrl = "http://localhost:3001/appointmenttmfiles";
// export const imagemasterPTUrl = "http://localhost:3001/masterptimages";
// export const filemasterPTUrl = "http://localhost:3001/masterptfiles";
// export const POAUrl = "http://localhost:3001/poa_file";
// export const INVUrl = "http://localhost:3001/inv_file";
// export const fileIncorporateUrl = "http://localhost:3001/incorporatefiles";
// export const litigationDocketCaseUrl =
//   "http://localhost:3001/litigation_docket_case";
// export const quotationUrl =
//   "http://localhost:3001/quotation_file";
// export const fileImmigrationDocket =
//   "http://localhost:3001/immigrationdocketfiles";
// export const previewFileUrl =
//   "http://localhost:3000/";

// API New Dtime
// export const apiUrl =
//   "https://apinewdtimedev.dcm.co.th/api_new_dtime_core_serive_dev/";
// export const apiUrlImmigration =
//   "https://apinewdtimedev.dcm.co.th/api_new_dtime_core_serive_dev/api_new_dtime_immigration_service_dev/";
// export const apiUrlInCorporate =
//   "https://apinewdtimedev.dcm.co.th/api_new_dtime_core_serive_dev/api_new_dtime_corporate_service_dev/";
// export const imageUrl =
//   "https://dcmdataprod.dcm.co.th:1479/api_data_prod/images";
// export const imageProdStorageUrl =
//   "https://dcmdataprod.dcm.co.th:1479/api_data_prod/leaveimage";
// export const fileSaleorderUrl =
//   "https://dcmdataprod.dcm.co.th:1479/api_data_prod/saleorderfiles";
// export const imageSaleorderUrl =
//   "https://dcmdataprod.dcm.co.th:1479/api_data_prod/saleorderimages";
// export const fileClearAdvance =
//   "https://dcmdataprod.dcm.co.th:1479/api_data_prod/clearadvancefiles";
// export const imageClearAdvance =
//   "https://dcmdataprod.dcm.co.th:1479/api_data_prod/clearadvanceimages";
// export const fileImmigration =
//   "https://dcmdataprod.dcm.co.th:1479/api_data_prod/immigrationfiles";
// export const fileImmigrationTransaction =
//   "https://dcmdataprod.dcm.co.th:1479/api_data_prod/immigrationtransactionfiles";
// export const filesDdocfile =
//   "https://dcmdataprod.dcm.co.th:1479/api_data_prod/d_docfile";
// export const pettyCashFile =
//   "https://dcmdataprod.dcm.co.th:1479/api_data_prod/petty_cash_file";
// export const pettyCashImage =
//   "https://dcmdataprod.dcm.co.th:1479/api_data_prod/petty_cash_image";
// export const leavequotaFile =
//   "https://dcmdataprod.dcm.co.th:1479/api_data_prod/leavequota";
// // //-----------at law --------------//
// export const imagemasterTMUrl =
//   "https://dcmdataprod.dcm.co.th:1479/api_data_prod/mastertmimages";
// export const filemasterTMUrl =
//   "https://dcmdataprod.dcm.co.th:1479/api_data_prod/mastertmfiles";
// export const imageappointmentTMUrl =
//   "https://dcmdataprod.dcm.co.th:1479/api_data_prod/appointmenttmimages";
// export const fileappointmentTMUrl =
//   "https://dcmdataprod.dcm.co.th:1479/api_data_prod/appointmenttmfiles";
// export const imagemasterPTUrl =
//   "https://dcmdataprod.dcm.co.th:1479/api_data_prod/masterptimages";
// export const filemasterPTUrl =
//   "https://dcmdataprod.dcm.co.th:1479/api_data_prod/masterptfiles";
// export const POAUrl =
//   "https://dcmdataprod.dcm.co.th:1479/api_data_prod/poa_file";
// export const INVUrl =
//   "https://dcmdataprod.dcm.co.th:1479/api_data_prod/inv_file";
// export const fileIncorporateUrl =
//   "https://dcmdataprod.dcm.co.th:1479/api_data_prod/incorporatefiles";
// export const litigationDocketCaseUrl =
//   "https://dcmdataprod.dcm.co.th:1479/api_data_prod/litigation_docket_case";
// export const fileImmigrationDocket =
//   "https://dcmdataprod.dcm.co.th:1479/api_data_prod/immigrationdocketfiles";
// export const quotationUrl =
//   "https://dcmdataprod.dcm.co.th:1479/api_data_prod/quotation_file";
// export const previewFileUrl =
//   "https://api-preview-dev.dcm.co.th:9677/api_preview_dev/";

// API Production
export const apiUrl = "https://api-dtime-service.dcm.co.th:10151/api_core_service";
export const apiUrlImmigration = "https://api-dtime-service.dcm.co.th:10151/api_immigration_service"; // <-- เพิ่ม
export const apiUrlInCorporate = "https://api-dtime-service.dcm.co.th:10151/api_new_dtime_corporate_service"; // <-- เพิ่ม
export const imageUrl = "https://api-dtime-prod.dcm.co.th:4153/api_data_prod/images";
export const quotationUrl = "https://api-dtime-prod.dcm.co.th:4153/api_data_prod/quotation_file";
export const imageProdStorageUrl = "https://api-dtime-prod.dcm.co.th:4153/api_data_prod/leaveimage";
export const fileSaleorderUrl = "https://api-dtime-prod.dcm.co.th:4153/api_data_prod/saleorderfiles";
export const imageSaleorderUrl = "https://api-dtime-prod.dcm.co.th:4153/api_data_prod/saleorderimages";
export const fileClearAdvance = "https://api-dtime-prod.dcm.co.th:4153/api_data_prod/clearadvancefiles";
export const imageClearAdvance = "https://api-dtime-prod.dcm.co.th:4153/api_data_prod/clearadvanceimages";
export const fileImmigration = "https://api-dtime-prod.dcm.co.th:4153/api_data_prod/immigrationfiles";
export const fileImmigrationTransaction =
  "https://api-dtime-prod.dcm.co.th:4153/api_data_prod/immigrationtransactionfiles";
export const filesDdocfile = "https://api-dtime-prod.dcm.co.th:4153/api_data_prod/d_docfile";
export const pettyCashFile = "https://api-dtime-prod.dcm.co.th:4153/api_data_prod/petty_cash_file";
export const pettyCashImage = "https://api-dtime-prod.dcm.co.th:4153/api_data_prod/petty_cash_image";
export const leavequotaFile = "https://api-dtime-prod.dcm.co.th:4153/api_data_prod/leavequota";
//-----------at law --------------//
export const imagemasterTMUrl = "https://api-dtime-prod.dcm.co.th:4153/api_data_prod/mastertmimages";
export const filemasterTMUrl = "https://api-dtime-prod.dcm.co.th:4153/api_data_prod/mastertmfiles";
export const imageappointmentTMUrl =
  "https://api-dtime-prod.dcm.co.th:4153/api_data_prod/appointmenttmimages";
export const fileappointmentTMUrl = "https://api-dtime-prod.dcm.co.th:4153/api_data_prod/appointmenttmfiles";
export const imagemasterPTUrl = "https://api-dtime-prod.dcm.co.th:4153/api_data_prod/masterptimages";
export const filemasterPTUrl = "https://api-dtime-prod.dcm.co.th:4153/api_data_prod/masterptfiles";
export const POAUrl = "https://api-dtime-prod.dcm.co.th:4153/api_data_prod/poa_file";
export const INVUrl = "https://api-dtime-prod.dcm.co.th:4153/api_data_prod/inv_file";
export const fileIncorporateUrl = "https://api-dtime-prod.dcm.co.th:4153/api_data_prod/incorporatefiles";
export const litigationDocketCaseUrl =
  "https://api-dtime-prod.dcm.co.th:4153/litigation_docket_case";
export const fileImmigrationDocket =
  "https://api-dtime-prod.dcm.co.th:4153/immigrationdocketfiles";
export const previewFileUrl =
  "https://docket.dcm.co.th/";

//api local
// export const apiUrlSME = "http://localhost:8085";
// export const imageUrlSME = "http://localhost:8085";
// export const agreementfileUrl = "http://localhost:8085/agreementfile";
// export const agreementfilepaymodeUrl = "http://localhost:8085/agreementfilepaymode";
// export const reqeuestMassageFileUrl = "http://localhost:8085/requestMassagefile";
// export const reqeuestMassageImageUrl = "http://localhost:8085/requestMassageimage";

//API SME MATE Dev
// export const apiUrlSME = "https://apidtime.dcm.co.th/api_sme_dev";
// export const imageUrlSME = "https://apidtime.dcm.co.th/api_sme_dev";
// export const agreementfileUrl =
//   "https://apidtime.dcm.co.th/api_sme_dev/agreementfile";
// export const agreementfilepaymodeUrl =
//   "https://apidtime.dcm.co.th/api_sme_dev/agreementfilepaymode";
// export const reqeuestMassageFileUrl =
//   "https://apidtime.dcm.co.th/api_sme_dev/requestMassagefile";
// export const reqeuestMassageImageUrl =
//   "https://apidtime.dcm.co.th/api_sme_dev/requestMassageimage";

// // //API SME MATE Poduction
export const apiUrlSME = "https://apidtime.dcm.co.th/api_sme_prod";
export const imageUrlSME = "https://apidtime.dcm.co.th/api_sme_prod";
export const agreementfileUrl = "https://apidtime.dcm.co.th/api_sme_prod/agreementfile";
export const agreementfilepaymodeUrl = "https://apidtime.dcm.co.th/api_sme_prod/agreementfilepaymode";
export const reqeuestMassageFileUrl = "https://apidtime.dcm.co.th/api_sme_prod/requestMassagefile";
export const reqeuestMassageImageUrl = "https://apidtime.dcm.co.th/api_sme_prod/requestMassageimage";
// export const billing_expense = {
//   billing_expense_url: `api_new_dtime_billing_dev`,
// };
// export const trademark_const = {
//   trademark_url: `api_new_dtime_trademark_dev`,
// };
// export const dispute_resolution_const = {
//   dispute_resolution_url: `api_new_dtime_dispute_resolution_dev`,
// };
export const billing_expense = {
  billing_expense_url: `api_billing_service`
}
export const trademark_const = {
  trademark_url: `api_trademark_service`
}
export const dispute_resolution_const = {
  dispute_resolution_url: `api_dispute_resolution_service`,
};
export const server = {
  LOGIN_URL: `dtime_login`,
  VERSION: `dtime_version`,
  EMAIL_URL: `dtime_email`,
  TOKEN_KEY: `dtime_token`,
  USERNAME: `dtime_username`,
  USER_ID: `dtime_user_id`,
  FULLNAME: `dtime_fullname`,
  ROLE: `dtime_role`,
  COMPANYID: `dtime_company_id`,
  DEPARTMENT_ID: `dtime_department_id`,
  POSITION_ID: `dtime_position_id`,
  AUTHORIZE_ID: `dtime_authorize_id`,
  USER_IMAGE_URL: `dtime_user_image_url`,

  //--------URL dtime-------------------//
  ADVANCE_CODE_URL: `advance_code`,
  ADVANCE_LOG_URL: `advance_log`,
  ADVANCE_H_URL: `advance_h`,
  ADVANCE_D_URL: `advance_d`,
  TIMESHEET_H_URL: `timesheet_h`,
  TIMESHEET_D_URL: `timesheet_d`,
  ACCOUNT_URL: `account`,
  REGISTER_URL: `register`,
  PRODUCT_URL: `product`,
  TRANSACTION_URL: `transaction`,
  REPORT_URL: `report`,
  CUSTOMER_URL: `customer`,
  CURRENCY_URL: `currency`,
  GROUP_MENU_URL: `group-menu`,
  MENU_DETAIL_URL: `menu-detail`,
  SETTING_GROUP_MENU_URL: `setting-group-menu`,
  SETTING_MENU_DETAIL_URL: `setting-menu-detail`,
  MASTER_COMPANY: `company`,
  MASTER_POSITION: `position`,
  MASTER_DEPARTMENT: `department`,
  APPROVE_LEVEL1: `approver_level1`,
  APPROVE_LEVEL1_EMAIL: `approver_level1_email`,
  MODELMENU: `modelmenu`,
  SALES_ORDER_H: `saleorder_h`,
  SALES_ORDER_D: `saleorder_d`,
  POSITION: `position`,
  JOBTITLE: `jobtitle`,
  ACTIVITY: "actiivity",
  LEAVE_QUOTA: "leave_quota",
  LEAVE_HISTORY: `leave-history`,
  LEAVE_HISTORY_QUOTA_DETAIL: `leave-history-quota-detail`,
  LEAVE_HOLIDAY: `leave-holiday`,
  COMPANY_EVENT: `company-event`,
  LEAVE_TYPE: `leave-type`,
  LEAVE_APPROVE_DETAIL: `leave-approve-detail`,
  INVOICE_H: `invoice_h`,
  INVOICE_SO: `invoice_so`,
  INVOICE_TS: `invoice_ts`,
  INVOICE_DOCREF: `invoice_docref`,
  INVOICE_MISCELLANEOUS: `miscellaneous`,
  INVOICE_TITLE: `invoice_title`,
  TRC_H: `trc_h`,
  TRC_D: `trc_D`,
  IM_PRINCIPAL: `im_principal`,
  IM_PARTICIPANT: `im_participant`,
  IM_DOCKET: `im_docket`,
  DOCTYPE: `doctype`,
  API_FILE_ATTACH_AT_LAW: `file-attach-at-law`,
  DOCTYPE_TEMPLATE: `doctitle_template`,
  DOCDROPDOWN: `docdropdown`,
  IM_INV: `IM_INV`,
  IP_INV: `IP_INV`,
  DOCTRANS: `doctrans`,
  DOCTRANS_H: `doctrans_h`,
  DOC_RUNNING: `doc-running`,
  IM_TRANSACTION: `im_transaction`,
  IM_TRANSACTION_DEPENDENT: `im_transaction_dependent`,
  INV_MIS_LIST: `inv_mis_list`,
  IM_MASTER_PLACE_OF_ISSUE: `im_master_place_of_issue`,
  IM_MASTER_WORK_PLACE_OF_ISSUE: `im_master_work_place_of_issue`,
  TRANSACTIONS_LOG: `transaction-log`,
  LOG_IN_OUT_LOG: `log-in-out-log`,
  TRANNING_H: `tranning_h`,
  TRANNING_D: `tranning_D`,
  TRANNING_EMAIL: `tranning_email`,
  TRANNING_USER: `tranning_user`,
  TRANNING_USER_D: `tranning_user_d`,
  API_PETTYCASH_H: `petty-cash-h`,
  API_PETTYCASH_D: `petty-cash-d`,
  PAYMENT_INVOICE: `payment-invoice`,
  FILE_ATTACH: `file-attach`,
  REGISTER_COMPANY: `register-company`,
  Approver_Management: `approver-management`,
  REPORT_ALL: "report_all",
  FIBASE_NOTIFICATION: `firebase_notification`,
  CLIENT_TIMELINE_STATUS: `client-timeline-status`,
  CLIENT_TIMELINE_HISTORY: `client-timeline-history`,
  CLIENT_TIMELINE_STATUS_CONFIG: `client-timeline-status-config`,
  QUOTATIONS: `quotations`,
  QUOTATIONS_ITEM: `quotations-item`,
  UPLOAD_FILE: `upload-route`,
  IM_NATIONALITY: `im_nationality`,
  IM_CASE_TYPE: `im_case_type`,
  //--------URL Incorporate Matter-------------------//
  // src/services/constants.js
  INCORPORATE_MATTER: `incorporate/incorporate-matter`,
  INCORPORATE_MATTER_PAGINATION: `incorporate/incorporate-matter-pagination`,
  INCORPORATE_DOCKET: `incorporate/incorporate-docket`,
  INCORPORATE_DOCKET_PAGINATION: `incorporate/incorporate-docket-pagination`,
  INCORPORATE_DOCKET_BY_MATTER: `incorporate/incorporate-docket-by-matter`,
  INCORPORATE_DOCKET_CHANGE_BY_DOCKET: `incorporate/incorporate-docket-change-by-docket`,
  INCORPORATE_DOCKET_CHANGE: `incorporate/incorporate-docket-change`,
  INCORPORATE_DOCKET_CHANGE_REPLACE_ALL: `incorporate/incorporate-docket-change-replace-all`,
  INCORPORATE_DOCKET_CHANGE_AGENCY: `incorporate/incorporate-docket-change-agency`,
  INCORPORATE_DOCKET_ATTACHMENT: `incorporate/incorporate-docket`,
  INCORPORATE_DOCKET_OVERVIEW: `incorporate/incorporate-docket-overview`,
  INCORPORATE_DOCKET_DOC_CATEGORY: `incorporate-docket-doc-category`,

  //--------URL IP AT LAW-------------------//
  MASTERTM: `mastertm`,
  OBJECTTYPE: `objecttype`,
  CONTACT: `contact`,
  TMUPDATESTATUS: `tmupdatestatus`,
  MASTERPT: `masterpt`,
  DOCUMENTTYPE: `documenttype`,
  APPOINTMENT: `appointment`,
  APPOINTMENT_ACTION: `appointment-documenttype-action`,
  COUNTRY: `country`,
  NOTICE: `notice`,
  POA: `poa`,
  OCR: `ocr`,
  OCRKW: `ocrkw`,
  IP_PRICE_LIST: `ip_price_list`,
  DOCTYE_ACTIONS: `doctype-actions`,
  MASTERPT_PRIORITY: `masterpt-priority`,
  CHAGE_MASTER_RECORD: `change-master-record`,
  DECISION: `decision`,
  SECTION_ACCESS_CONFIG: `section_access_config`,
  LITIGATION_COURT: `litigation-court`,
  LITIGATION_COURT_STATUS: `litigation-court-status`,
  LITIGATION_CASE_TYPE: `litigation-casetype`,
  LITIGATION_COURT_LEVEL: `litigation-courtlevel`,
  LITIGATION_DEPARTMENT: `litigation-department`,
  LITIGATION_DOCKET: `litigation-docket`,
  LITIGATION_ADDITIONAL_LAWYERS: `litigation-additional-lawyers`,
  LITIGATION_HEARINGS: `litigation-hearings`,
};
